const Unit = {

    // FIELDS
    "name": "Name",
    "short_name": "Short Name",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "unit": "Unit",

    // ERROR
    "error_name": "Enter Name",
    "error_short_name": "Enter Short Name",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": "NAME",
    "table_short_name": "SHORT NAME",
    "table_status": "STATUS",

}

export default Unit;